import { FormikProvider, useFormik } from "formik";
import { Modal } from "../components/Modal/Modal";
import { TextInput } from "../components/Forms/TextField";
import { Loader } from "../components/Loader";
import { Button } from "../components/Buttons/Button";
import * as yup from "yup";
import { makePayment } from "../utils/api.service";
import { useState } from "react";
import { toast } from "react-hot-toast";


interface PaymentModalProp {
  onClose: (re?:any) => void;
  show: boolean;
  parentGuid: string;
}
export const PaymentModal = ({
  onClose,
  show,
  parentGuid,
}: PaymentModalProp) => {
  const [modalState, setModalState] = useState<"payment" | "error" | "success">(
    "payment"
  );
  const [errMessage, setErrMessage] = useState("");
  const [response, setResponse ] = useState([])
  const form = useFormik({
    initialValues: {
      amountPaid: 0,
    },
    validationSchema: yup.object({
      amountPaid: yup.string().required().label("Amount"),
    }),
    onSubmit: async (values) => {
      const accessToken = localStorage.getItem("X-PC-ACCESS") ?? ""
      try {
        const res = await makePayment({ parentGuid, ...values }, accessToken);
        if (res.data.responseCode !== "00") {
          setModalState("error");
          setErrMessage(res.data.responseMessage);
        } else {
          setModalState("success");
          setResponse(res.data.data)
        }
      } catch (error: any) {
        toast.error(error.response.data.responseMessage);
      }
    },
  });

  

  return (
    <Modal onClose={() => onClose(response)} show={show} title="Make Payment">
      {modalState === "payment" && (
        <FormikProvider value={form}>
          <form onSubmit={form.handleSubmit} className="space-y-[28px]">
            <TextInput
              label="Enter amount"
              context
              type="number"
              {...form.getFieldProps("amountPaid")}
            />

            {form.isSubmitting ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : (
              <Button btnText="Pay" fullWidth />
            )}
          </form>
        </FormikProvider>
      )}

      {modalState === "error" && (
        <div className="px-4  text-center">
          <img
            src="/icons/error.svg"
            className="mx-auto w-[70px] mb-4"
            alt=""
          />
          <div className="font-semibold text-[#C31B1B]">Payment failed</div>
          <p className="font-normal text-sm leading-1">{errMessage}</p>

          <Button
            btnText="Retry"
            fullWidth
            onClick={() => setModalState("payment")}
          />
        </div>
      )}
      {modalState === "success" && (
        <div className="px-4  text-center">
          <img
            src="/icons/green-check.svg"
            className="mx-auto w-[70px] mb-4"
            alt=""
          />
          <div className="font-base">Payment successful</div>

          <Button
            btnText="View receipt"
            onClick={() => {
              onClose(response);
              setModalState("payment");
              form.resetForm();
            }}
          />
        </div>
      )}
    </Modal>
  );
};
